"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalDivider = void 0;
var VerticalDivider_styles_1 = require("./VerticalDivider.styles");
var VerticalDivider_base_1 = require("./VerticalDivider.base");
var Utilities_1 = require("../../Utilities");
exports.VerticalDivider = Utilities_1.styled(VerticalDivider_base_1.VerticalDividerBase, VerticalDivider_styles_1.getStyles, undefined, {
    scope: 'VerticalDivider',
});
//# sourceMappingURL=VerticalDivider.js.map